import React, { useState, useEffect } from 'react';

import { CardGiftcard } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { 
  Character
} from "@dndModels";

import CharacterGiftInput from "@dndComponents/character/gifts/CharacterGiftInput";
import CharacterExtraFeatInput from "@dndComponents/character/gifts/CharacterExtraFeatInput";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import CenteredMenu from "@components/input/menus/CenteredMenu";

interface Props {
  character: Character;
  disabled: boolean;
}

export default function CharacterGiftButton({
  character: char,
  disabled,
}: Props) {
  const [flashing, setFlashing] = useState((
    char.spirit.gifts.filter(o => 
      o.needs_attention).length > 0 || 
    char.spirit.extra_feats.filter(o => 
      o.needs_attention).length > 0
  ));
  const [open, setOpen] = useState(false);
  const [view, setView] = useState("Extra Feats");
  // NEED TO SUBSCRIBE HERE

  const renderExtras = () => {
    const wide_mode = window.innerWidth > 800;
    return (
      <ModalOrDrawer 
        open={ open } 
        // drawer_only
        width={ wide_mode ? 800 : undefined }
        full_page
        // drawer_only
        onClose={() => {
          setOpen(false);
          char.subscription_holder.modalClosed();
        }}>
        { open &&
          <Grid container spacing={0} direction="row" 
            style={{ maxHeight: window.innerHeight - 34 }}>
            <Grid
              size={{
                xs: 12
              }}>                
              <CenteredMenu
                options={["Extra Feats","Gifts"]}
                selected={view}
                onSelect={setView}
              />
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              { view === "Gifts" ? 
                <CharacterGiftInput
                  character={char}
                  onChange={(changed: Character, do_main: boolean) => {
                    // debugger;
                    char.changed();
                    char.subscription_holder.recalculate();
                  }}
                />
              :
                <CharacterExtraFeatInput
                  character={char}
                  onChange={(changed: Character, do_main: boolean) => {
                    char.changed();
                    char.subscription_holder.recalculate();
                  }}
                />
              }
            </Grid>
          </Grid>
        }
      </ModalOrDrawer>
    );
  }

  return (
    <>
      <Tooltip title="Extra Feats &amp; Gifts">
        <CardGiftcard
          className="clickable"
          onClick={() => {
            if (!disabled) {
              setOpen(true);
            }
          }}
        />
      </Tooltip>
      { renderExtras() }
    </>
  ); 
}
